// Configuración de la API
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Configuración de Stripe
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_51JPBNOIXb6RBKifgTnygkWBpPHR9huKVhWIw3j3VNGAWr1K51qflMoTY7Pafl2pRdLYahonf0b6KPZlMFU0CWuGj00cOhBUtq8';

export const API_ENDPOINTS = {
  STORES: `${API_BASE_URL}/api/stores`,
  BENEFITS: `${API_BASE_URL}/api/benefits`,
  NOTIFICATIONS: `${API_BASE_URL}/api/notifications`,
  USER: `${API_BASE_URL}/api/user`,
  MEMBERSHIP: `${API_BASE_URL}/api/membership/plan`,
  REGISTER: `${API_BASE_URL}/api/register`,
  LOGIN: `${API_BASE_URL}/api/login`,
  FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
  PAYMENT_INTENT: `${API_BASE_URL}/api/payment-intent`,
  SUBSCRIPTION_CREATE: `${API_BASE_URL}/api/subscription/create`,
  SUBSCRIPTION_PRICE: `${API_BASE_URL}/api/subscription/price`,
  SUBSCRIPTION: `${API_BASE_URL}/api/subscription`,
  SUBSCRIPTION_REFRESH: `${API_BASE_URL}/api/subscription/refresh`,
  SUBSCRIPTION_CONFIRM_PAYMENT: `${API_BASE_URL}/api/subscription/confirm-payment`,
  SUBSCRIPTION_CANCEL: `${API_BASE_URL}/api/subscription/cancel`,
  // Admin endpoints
  ADMIN_STORES: `${API_BASE_URL}/api/admin/stores`,
  ADMIN_FEATURED_STORES: `${API_BASE_URL}/api/admin/featured-stores`,
  ADMIN_BRANDS: `${API_BASE_URL}/api/admin/brands`,
  ADMIN_PROMOTIONS: `${API_BASE_URL}/api/admin/promotions`,
  ADMIN_ADS: `${API_BASE_URL}/api/admin/ads`,
  ADMIN_SUBSCRIBERS: `${API_BASE_URL}/api/admin/subscribers`,
  ADMIN_QR_REDEMPTIONS: `${API_BASE_URL}/api/admin/qr-redemptions`,
  ADMIN_OUTLET_MAP: `${API_BASE_URL}/api/admin/outlet-map`,
};

